import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=6e47f2b2&scoped=true&"
import script from "./ready.vue?vue&type=script&lang=js&"
export * from "./ready.vue?vue&type=script&lang=js&"
import style0 from "./ready.vue?vue&type=style&index=0&id=6e47f2b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47f2b2",
  null
  
)

export default component.exports